import React, { Component } from "react";


import workshop from '../assets/images/workshops.jpg'
import Infi from '../assets/images/Infi.jpg'
import {NavLink} from "react-router-dom";
import { Image, Button, Grid } from "semantic-ui-react";

import '../assets/styles/events.scss';

import events1 from '../assets/images/kites.png'
import events2 from '../assets/images/doodle2.png'
import Proshows from "../assets/images/flashback/five.jpg";
import {withUserContext} from "../components/ModalContext";


class ComingSoon extends Component {

  render() {

      if(this.props.redirect){
          this.props.setRedirect(false);
      }
    return (
      <div className={"coming-soon-page"} >
        {/*<Image className="pic1" src={events1} size={'large'} style={{marginTop:'-3%'}}/>*/}

        {/*<div className="pic2">*/}
        
        <Grid stackable style={{paddingTop:'1%', paddingBottom:'2%', paddingLeft:'6%'}}>
        <Grid.Row columns={3}>
            <Grid.Column>
                <div  className={"competition-details-card"}>
                    <Image
                        src={Proshows}
                        className={"competition-photo"}
                    />
                    <div className={"competition-detail-section"}>

                        <p className={"competition-details"}>
                            Take a break from the grind and witness amazing shows brought to you at home for free! Register for an exhilarating experience now!
                        </p>

                        <div style={{textAlign:'center'}}>
                            <NavLink to={'/proshows'} >
                                <Button className='rulesButton'>
                                    PROSHOWS
                                </Button>
                            </NavLink>
                            <br/>

                        </div>
                    </div>
                </div>
            </Grid.Column>
        <Grid.Column>
        <div  className={"competition-details-card"}>
            <Image
                src={Infi}
                className={"competition-photo"}
            />
            <div className={"competition-detail-section"}>

                <p className={"competition-details"}>
                  Infi events are synonymous with fun. Here we bring you a list of competitions to enjoy your time as well as to get rid of that piling up stress!
                </p>

                <div style={{textAlign:'center'}}>
                <NavLink to={'/infi'} >
                  <Button className='rulesButton'>
                    INFORMAL <br/> EVENTS
                  </Button>
              </NavLink>
                  <br/>

                </div>
            </div>
        </div>
        </Grid.Column>

        <Grid.Column>
        <div  className={"competition-details-card"}>
            <Image
                src={workshop}
                className={"competition-photo"}
            />
            <div className={"competition-detail-section"}>

                <p className={"competition-details"}>
                Learning should never stop, and it's time to get at par with all those people showing off their technical skills. Join our Workshop Series to sharpen your skills and keep yourself updated with the latest developments in technology.
                </p>

                <div style={{textAlign:'center'}}>
                  <a target={"_blank"} href={'https://www.meraevents.com/ticketWidget?eventId=239329&ucode=organizer&wcode=9063CD-9063CD-333333-9063CD-&theme=1&rcode='} >
                  <Button className='rulesButton'>
                      WORKSHOPS
                  </Button>
                  </a>
                  <br/>
                </div>
            </div>
        </div>
        </Grid.Column>
        </Grid.Row>
        </Grid>
        {/*<Image className={'Infi1'} src={events2} size={'medium'} />*/}
        </div>

    );
  }
}

export default withUserContext(ComingSoon);





